<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="form" label-width="120px">
        <el-form-item label="简介">
          <el-input type="textarea" placeholder="请输入简介" maxlength="2000" show-word-limit
                    v-model="formData.content"></el-input>
        </el-form-item>
        <el-form-item label="图片编辑"> 
          <el-upload
                  :action="uploadImg"
                  :data="data_"
                  list-type="picture-card"
                  :limit="9"
                  :file-list="fileList"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <p>(图片大小不超过2M,支持jpg、png格式，最多可上传9张)</p>
        </el-form-item>
        <el-form-item label="插入商品">
          <el-button size="small" @click="onInsertCont(2)">选择商品</el-button>
          <span class="noticeP pl10">最多选择6件商品</span>
          <div>
            <el-tag type="info" v-for="item in formData.goods_arr" :key="item.id">{{item.goods_name}}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="插入表单">
          <el-button size="small" @click="onInsertCont(1)">选择表单</el-button>
           <span class="noticeP pl10">最多选择6个表单</span>
          <div>
            <el-tag type="info" v-for="item in formData.form_arr" :key="item.id">{{item.title}}</el-tag>
          </div>           
        </el-form-item>        
        <el-form-item label="所属栏目">
          <el-select v-model="formData.pro_id" placeholder="请选择区">
            <el-option
                    v-for="item in optionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit(0)" size="small">{{pageTypes=='add'?'仅保存':'保存并取消发布'}}</el-button>
          <el-button type="primary" @click="onSubmit(1)" size="small">发布</el-button>
        </el-form-item>
      </el-form>
    </div>
    <momentsEditDialog :visible.sync="dialogTableVisible" :page="pageDialog" :type="tableType" :property="tableData" :formdata="tableType==2?goodObj:formObj"
      @loadMoreGoodsOrForm="loadMoreGoodsOrForm" @updatePageInfo="updatePageInfo"></momentsEditDialog>     
  </div>
</template>
<script>
import api from '@/api.js';
import momentsEditDialog from "@/components/dialog/momentsEditDialog.vue";
import { pagination } from "@/util/util.js";
export default {
  name: "publishPicture",
  components: {
    momentsEditDialog
  },
  props: ["optionList", 'formData', 'pageType'],
  data() {
    return {
      uploadImg: api.uploadTokenImg,
      data_: {token: sessionStorage.getItem("token")},
      form: {
        dynamic_type: 1, // 	整型 	必填 	- 	- 	动态类型(0文章、1图文)
        title: '', // 	varchar 	非必填 	- 	- 	文章标题(动态类型为文章时必填)
        biref: '', // 	varchar 	非必填 	- 	- 	文章简介
        pro_id: '', //	整型 	非必填 	- 	- 	所属栏目
        content: '', // 	varchar 	非必填 	- 	- 	文章内容(动态类型为文章时必填)
        pic: '', //	varchar 	非必填 	- 	- 	图片(当动态类型为图文时可为多张，多张图片用逗号分隔)
        form_id: '', // 	整型 	非必填 	- 	- 	表单id
        button_name: '', // 	varchar 	非必填 	- 	- 	按钮名称
        is_sub: 0, // 	varchar 	必填 	- 	- 	是否发布(0仅保存、1已发布)
        goods_arr: [],
        form_arr: []
      },
      fileList: [],
      pageTypes: this.pageType,
      formData_: this.formData,
      dialogImageUrl: "",
      dialogVisible: false,
        dialogTableVisible: false,
        pageDialog: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        }, 
        tableType: 0,
        tableData: [],
        goodObj: {
          check_type: 1,    // 筛选类型(0全部、1已上架、2已售罄、3未上架)
          goods_type: 0,    // 商品类型(0全部、1实体商品-仅线上展示、2实体商品-支持线上支付、3虚拟商品
          name: "",         // 商品名称
          cat_id: ""        // 分类id
        },
        formObj: {
          title: "",        // 表单名称
          status: 1         // 查看状态(0全部、1已启用、2未启用)
        }      
    };
  },
  created() {
    let Pic_list = []
    if (Array.isArray(this.formData.pic)) {
      Pic_list = this.formData.pic;
    } else {
      Pic_list = this.formData.pic.split(',');
    }
    for (let i in Pic_list) {
      let pic_new = {};
      pic_new.name = i;
      pic_new.url = Pic_list[i];
      this.fileList.push(pic_new);
    }
    this.formData.pic = Pic_list
    this.form = this.formData
  },
  methods: {
    onSubmit(type) {
      this.form.is_sub = type;
      this.$emit('saveFrom', this.form);
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        this.fileList = fileList
        let picList = []
        for (let i in fileList) {
          if (fileList[i].response) {
            picList.push(fileList[i].response.path)
          } else {
            picList.push(fileList[i].url)
          }
        };
        this.form.pic = picList;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    handleRemove(file, fileList) {
      let picLine = ''
      if (file.response) {
        picLine = this.form.pic.indexOf(file.response.path)
      } else{
        picLine = this.form.pic.indexOf(file.url)
      }
      this.fileList.splice(picLine, 1)
      this.form.pic.splice(picLine, 1)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      this.loadingStatus = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
        customClass: 'fontColor'
      });
      return isLt2M;
    },
    onInsertCont(type) {
      this.pageDialog.pageindex = 1;
      this.tableType = type;
      if (type == 2) {
        this.goodObj.check_type = 1;
        this.goodObj.goods_type = 0;
        this.goodObj.name = '';
        this.goodObj.cat_id = '';
      }
      if (type == 1) {
        this.formObj.title = '';
        this.formObj.status = 1;
      }
      this.initGoodsOrForm(0, type);
    },
    // 关联商品、表单
    initGoodsOrForm(num, type) {
      let tableObj;
      if (type == 2) {  // type 2-选择已上架商品 1-选择表单 
        tableObj = this.goodObj;
      } else {
        tableObj = this.formObj;
      }
      tableObj.page = this.pageDialog.pageindex;
      this.axios   
        .post(type == 2 ? api.goods_index : api.companyadmin_form_list, tableObj)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.pageDialog.total = response.data.all_page;
            if (num == 0) {
              this.dialogTableVisible = true;
            }
          }
        })
        .catch(() => {});      
    },  
    // 加载更多数据
    loadMoreGoodsOrForm(e) {
      this.pageDialog.pageindex = e.pageindex;
      if (e.type == 2) {
        this.goodObj = e.obj;
      } else {
        this.formObj = e.obj;
      }
      this.initGoodsOrForm(1, e.type);
    },
    // 更新当前页面数据
    updatePageInfo(e) {  
      if (e.type == 2) {
        this.form.goods_arr = e.obj;
        this.$set(this.form, 'goods_arr', this.form.goods_arr);
      } else {
        this.form.form_arr = e.obj;
        this.$set(this.form, 'form_arr', this.form.form_arr);
      }  
    }    
  },
  mounted() {
  }
};
</script>
